<script>
  import Icon from "$lib/components/Icon.svelte";
  import { isExternalUrl } from "$lib/utilities/url-helpers";

  export let id;
  export let url;
  export let text = "";

  export let icon = {
    type: "store",
    leading: true,
    size: "sm"
  };

  const isExternal = isExternalUrl(url);
</script>

<a
  href={url}
  {id}
  class="w-full flex no-underline px-24 py-16 lg:px-16 lg:py-12 bg-teal-600 text-size-12 leading-[133%] lg:leading-[80%] text-white hover:text-white active:!text-white focus:text-white focus:bg-teal-600 focus:rounded-0 focus-visible:outline-none"
  target={isExternal ? "_blank" : null}
  rel={isExternal ? "noopener noreferrer" : null}
>
  <div class="w-full flex justify-between">
    <div class="flex justify-start lg:justify-center items-center">
      {#if !!icon?.type && icon?.leading}
        <Icon type={icon.type} size={icon.size} class="mr-4" />
      {/if}

      <span>{text}</span>

      {#if !!icon?.type && icon?.trailing}
        <Icon type={icon.type} size={icon.size} class="ml-8" />
      {/if}
    </div>

    <div class="lg:hidden">
      <Icon type="chevron-right" />
    </div>
  </div>
</a>
